<template>
  <div>
    <!-- <a-list
        :grid="{ gutter: 16, column: 1 }"
    >
        <a-list-item>
            <task-item></task-item>
        </a-list-item>
    </a-list> -->
    <a-list
        :grid="{ gutter: 16, column: 1 }"
        :dataSource="PushStatus"
    >
        <a-list-item slot="renderItem" slot-scope="item, index">
            <task-item :dataSource="item" @delete="DELETE_PUSH_STATUS({index})"></task-item>
        </a-list-item>
    </a-list>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TaskItem from './TaskItem'
export default {
    components: {
        TaskItem
    },
    data () {
        return {
            data:[]
        }
    },
    computed: {
        PushStatus(){
            return this.$store.state.batchpush.PushStatus
        }
    },
    mounted () {

    },
    methods: {
        ...mapMutations([
            'DELETE_PUSH_STATUS'
        ])
    }
}
</script>

<style lang="less" scoped>

</style>
